{
  "#AI_TABLE_EXTRACTOR": {
    "TITLE": "Belegleser",
    "UPLOAD_PAGE_TITLE": "Beleg hochladen",
    "UPLOAD_PDF_ONLY": "Nur PDF-Dateien werden unterstützt.",
    "UPLOAD_OPEN_DIALOG": "PDF auswählen",
    "UPLOAD_DROP_HINT": "PDF hierher ziehen",
    "UPLOADING": "Beleg wird hochgeladen …",
    "UPLOAD_FAILED": "Hochladen fehlgeschlagen",
    "REVIEW_PAGE_TITLE": "Beleg prüfen",
    "PROCESSING_MODEL_HINT": "Der erste Lauf kann länger dauern – Modelle werden geladen.",
    "PROCESSING_STEP": {
      "READING": "Dokument wird gelesen",
      "RECOGNIZING": "Positionen werden erkannt",
      "CHECKING": "Beträge werden geprüft",
      "MATCHING": "Belegdaten werden zugeordnet",
      "PREPARING": "Ergebnis wird aufbereitet",
      "ALMOST": "Gleich fertig",
      "TEMPLATE": "Lieferanten-Template wird angewandt"
    },
    "PROCESSING_FAILED": "Verarbeitung fehlgeschlagen",
    "ERROR_TIMEOUT": "Zeitüberschreitung bei der Verarbeitung.",
    "ERROR_UNSUPPORTED_VERSION": "Inkompatible Version des Extraktionsdienstes.",
    "BACK_TO_UPLOAD": "Neuen Beleg hochladen",
    "IMPORT_NEW_PDF": "Neues PDF hochladen",
    "TRANSFER": {
      "LABEL": "Artikel übernehmen",
      "CHOOSE_TITLE": "Artikel übernehmen",
      "CREATE": "Neuen Beleg erstellen",
      "APPEND": "Zu bestehendem Beleg hinzufügen",
      "APPENDED": "{{n}} Position(en) zu {{document}} hinzugefügt."
    },
    "CREATE_RECEIPT_WIZARD_TITLE": "Beleg erstellen",
    "CREATE_RECEIPT_ITEMS_FAILED": "{{failed}} von {{total}} Positionen konnten nicht übernommen werden.",
    "CREATE_RECEIPT_CUSTOMIZATION_FAILED": "Bei {{n}} Position(en) konnte der Belegtext nicht übernommen werden.",
    "CREATE_RECEIPT_NOT_CUSTOMIZABLE": "Artikel {{key}} ist kein manueller Artikel – der Belegtext konnte nicht übernommen werden.",
    "CREATE_RECEIPT_PRICES_FAILED": "Bei {{n}} Position(en) konnte der Preis nicht übernommen werden.",
    "CREATE_RECEIPT_UNITS_FAILED": "Bei {{n}} Position(en) konnte die Softline-Einheit nicht gesetzt werden.",
    "CREATE_RECEIPT_DISCOUNTS_FAILED": "Bei {{n}} Position(en) konnte der Aufschlag nicht als Rabatt übernommen werden.",
    "SUPPLIER": {
      "LABEL": "SOFTLINE Lieferant",
      "DETECTED_AS": "Erkannt als {{company}}",
      "NUMBER": "Lief.-Nr. {{n}}",
      "RESOLVING": "Softline-Lieferant wird gesucht …",
      "UNRESOLVED": "Kein Softline-Lieferant zugeordnet",
      "PROFILE_READY": "DTI-Profil",
      "PROFILE_MISSING": "Kein DTI-Profil",
      "PICK_PLACEHOLDER": "Lieferant wählen …"
    },
    "NO_RESULT_YET": "Noch kein Ergebnis",
    "POSITIONS_RECOGNIZED": "Erkannte Positionen",
    "POSITIONS_TAB": "Positionen",
    "METADATA_TAB": "Belegdaten",
    "SALES_TAB": "Verkauf",
    "SALES_PREVIEW": {
      "ARTICLE": "Softline-Artikel",
      "TEXT_POSITION": "Textposition",
      "LEGEND": "Zugeordnete Artikel werden als Artikelposition übernommen, manuelle und nicht zugeordnete Positionen als manueller Artikel des Lieferanten mit dem Belegtext.",
      "LEGEND_TEXT": "Ohne DTI-Profil des Lieferanten werden nicht zugeordnete Positionen als Textpositionen übernommen.",
      "QUANTITY_INVALID": "Keine gültige Menge — die Position wird mit Menge 1 angelegt.",
      "UNDECIDED_AS_MANUAL": "→ manueller Artikel",
      "UNDECIDED_AS_TEXT": "→ Textposition"
    },
    "MATCH": {
      "LABEL": "SOFTLINE Artikel",
      "MATCHED": "Zugeordnet",
      "SUGGESTED": "Vorschlag",
      "MANUAL": "Manueller Artikel",
      "UNDECIDED": "Nicht zugeordnet",
      "PENDING": "Artikel wird gesucht …",
      "CONFIRM": "Übernehmen",
      "ASSIGN": "Zuordnen",
      "CHANGE": "Ändern",
      "CLEAR": "Zuordnung entfernen",
      "UNDECIDED_HINT_MANUAL": "Nicht zugeordnet — wird als manueller Artikel des Lieferanten übernommen.",
      "UNDECIDED_HINT_TEXT": "Nicht zugeordnet — wird als Textposition übernommen.",
      "MANUAL_HINT": "Wird auf dem manuellen Artikel des Lieferanten mit dem Belegtext angelegt.",
      "TEXT": "Textposition",
      "TEXT_HINT": "Wird als Textposition mit dem Belegtext angelegt – ohne Artikel, Menge und Preis.",
      "MATCH_ALL": "Artikel zuordnen",
      "SEARCH_FAILED": "{{n}} Position(en) konnten nicht gesucht werden.",
      "VIA": {
        "EAN": "gefunden über EAN",
        "SUPPLIER_NUMBER": "gefunden über Lief.-Art-Nr.",
        "KEY": "gefunden über Artikel-Nr.",
        "NAME": "gefunden über Bezeichnung",
        "MANUAL": "manuell zugeordnet"
      }
    },
    "ASSIGN": {
      "TITLE": "Position zuordnen",
      "CANDIDATES": "Softline-Artikel",
      "NO_CANDIDATES": "Kein passender Artikel gefunden — Artikel suchen oder ohne Artikel übernehmen.",
      "SEARCH_PLACEHOLDER": "Artikel suchen …",
      "SUPPLIER_NUMBER": "Lief.-Art-Nr. {{n}}",
      "MANUAL_SECTION": "Manueller Artikel",
      "MANUAL_OPTION": "Als manuellen Artikel übernehmen",
      "MANUAL_OPTION_HINT": "Die Position wird auf dem manuellen Artikel des Lieferanten angelegt und trägt den Belegtext.",
      "TEXT_SECTION": "Textposition",
      "TEXT_OPTION": "Als Textposition übernehmen",
      "TEXT_OPTION_HINT": "Kein DTI-Profil mit manuellem Artikel – die Position wird als Textposition mit dem Belegtext angelegt, ohne Artikel, Menge und Preis.",
      "APPLY": "Zuordnen",
      "CANCEL": "Abbrechen"
    },
    "UNDECIDED": {
      "TITLE": "Nicht zugeordnete Positionen",
      "INTRO_MANUAL": "{{n}} Position(en) sind keinem Artikel zugeordnet. Alle gesammelt als manueller Artikel des Lieferanten übernehmen – oder zurück zur Zuordnung.",
      "INTRO_TEXT": "{{n}} Position(en) sind keinem Artikel zugeordnet. Alle gesammelt als Textposition übernehmen – oder zurück zur Zuordnung.",
      "SUGGESTIONS_DROPPED": "Vorschläge werden dabei verworfen – zum Übernehmen eines Vorschlags zurückgehen und ihn bestätigen.",
      "TAKE_ALL_MANUAL": "Alle als manueller Artikel übernehmen",
      "TAKE_ALL_TEXT": "Alle als Textposition übernehmen",
      "BACK": "Zurück"
    },
    "ADD_TO_DOCUMENT": {
      "TITLE": "Zu bestehendem Beleg hinzufügen",
      "NUMBER": "Belegnummer",
      "NUMBER_PLACEHOLDER": "z. B. 4711",
      "SEARCH": "Suchen",
      "INVALID_NUMBER": "Bitte eine Belegnummer eingeben (nur Ziffern).",
      "NOT_FOUND": "Kein Beleg mit der Nummer {{n}} gefunden.",
      "SEVERAL": "Mehrere Belege mit der Nummer {{n}} – bitte auswählen.",
      "READ_ONLY": "{{document}} ist abgeschlossen und kann nicht mehr geändert werden.",
      "READ_ONLY_BADGE": "abgeschlossen",
      "LOOKUP_FAILED": "Beleg konnte nicht geladen werden.",
      "CUSTOMER": "Kunde",
      "DATE": "Belegdatum",
      "ADD": "{{n}} Position(en) hinzufügen",
      "CANCEL": "Abbrechen"
    },
    "CREATE_OPTIONS": {
      "TITLE": "Beleg erstellen – Preise",
      "TITLE_APPEND": "Positionen hinzufügen – Preise",
      "PRICE_SOURCE": "Preisquelle",
      "PRICE_DOCUMENT": "Preis laut Lieferant + Aufschlag",
      "PRICE_BACKEND": "Preisfindung VerkaufsWEB",
      "PRICE_DOCUMENT_HINT": "Der Einzelpreis laut Beleg wird um den Aufschlag erhöht und fix auf die Position übernommen.",
      "PRICE_BACKEND_HINT": "Zugeordnete Artikel werden vom Verkauf bepreist; manuelle Artikel erhalten trotzdem den Belegpreis mit Aufschlag.",
      "MARKUP": "Aufschlag (%)",
      "MARKUP_INVALID": "Bitte einen Prozentsatz eingeben (z. B. 15 oder -5).",
      "MARKUP_DISCOUNT_HINT": "Der Aufschlag wird als negativer Rabatt in die Spalte \"{{column}}\" geschrieben – der Einzelpreis bleibt der Belegpreis.",
      "MARKUP_ROW": "Aufschlag %",
      "MARKUP_RESET": "Auf allgemeinen Aufschlag zurücksetzen",
      "POSITIONS": "Positionen",
      "DOCUMENT_PRICE": "EP laut Beleg",
      "SALES_PRICE": "VK-Preis",
      "BACKEND_PRICED": "Preisfindung",
      "NO_PRICE": "—",
      "NO_DOCUMENT_PRICE": "Kein lesbarer Einzelpreis am Beleg — die Position wird ohne Preis angelegt.",
      "NO_DOCUMENT_PRICE_SHORT": "kein EP",
      "UNIT_MAPPED": "Belegeinheit {{unit}} wird als {{target}} angelegt",
      "UNDECIDED_MANUAL": "{{n}} nicht zugeordnete Position(en) werden als manueller Artikel übernommen.",
      "UNDECIDED_TEXT": "{{n}} nicht zugeordnete Position(en) werden als Textposition übernommen.",
      "CONTINUE": "Weiter",
      "CANCEL": "Abbrechen"
    },
    "ADD_POSITION": "+ Position hinzufügen",
    "KEYBOARD_HINT": "↑ ↓ Position wechseln (↓ am Ende: neue Position) · Enter öffnet · Z zuordnen · Entf entfernt · ← → Tab wechseln",
    "DELETE_POSITION": "Entfernen",
    "DELETE_POSITION_WITH_CHILDREN": "Mit Unterpositionen entfernen",
    "ADD_SUB_POSITION": "+ Unterposition",
    "INDENT": "Einrücken",
    "OUTDENT": "Ausrücken",
    "SUB_POSITIONS_COUNT": "{{n}} Unterpos.",
    "SHOW_SUB_POSITIONS": "Unterpositionen anzeigen",
    "HIDE_SUB_POSITIONS": "Unterpositionen ausblenden",
    "DELETE_SELECTED": "Auswahl entfernen",
    "DELETE": {
      "TITLE": "Positionen entfernen",
      "QUESTION": "{{n}} Position(en) wirklich entfernen?"
    },
    "NO_POSITIONS": "Keine Positionen erkannt.",
    "POSITION_SHORT": "Pos.",
    "EXPAND_POSITION": "Details anzeigen",
    "COLLAPSE_POSITION": "Details ausblenden",
    "SELECT_POSITION": "Position auswählen",
    "MARK_HINT": "Bereich im PDF markieren — Box über den Wert ziehen.",
    "MARK_ASSIGNED": "Zugeordnet: {{text}}",
    "MARK_CANCEL": "Abbrechen",
    "MARK_BANNER": "Rahmen für „{{field}}“ auf das PDF ziehen",
    "MARK_BANNER_GENERIC": "Rahmen auf das PDF ziehen",
    "TOTALS_NET": "Endsumme Netto",
    "TOTALS_VAT": "USt-Gesamtbetrag",
    "TOTALS_GROSS": "Rechnungsbetrag",
    "PLAUSIBILITY": {
      "TITLE": "Plausibilitätscheck",
      "CHECK": "Plausibilitätscheck",
      "SUMMARY_OK": "Alle Prüfungen bestanden.",
      "SUMMARY_FAILED": "{{n}} Prüfung(en) stimmen nicht.",
      "SUMMARY_NOT_CHECKABLE_SUFFIX": " ({{n}} nicht prüfbar)",
      "SUMMARY_NOT_CHECKABLE": "Keine Abweichung, aber {{n}} Prüfung(en) nicht prüfbar (Werte fehlen).",
      "ADD_SPECIAL_POSITION": "+ Sonderposition hinzufügen",
      "SPECIAL_POSITION": "Sonderposition",
      "SPECIAL_POSITION_ADDED": "Sonderposition ({{net}} €) hinzugefügt."
    },
    "JSON": {
      "TITLE": "Finales JSON",
      "SHOW": "JSON",
      "COPY": "Kopieren",
      "COPIED": "JSON in die Zwischenablage kopiert.",
      "COPY_FAILED": "Kopieren nicht möglich."
    },
    "STATE": {
      "ARITHMETIC_MISMATCH": "Rechnung stimmt nicht",
      "DISCOUNT_UNPROVEN": "Rabatt unbewiesen"
    },
    "FIELD": {
      "ITEM_NUMBER": "Pos.-Nr.",
      "PRODUCT_NUMBER": "Artikel-Nr.",
      "EAN": "EAN",
      "DESCRIPTION": "Bezeichnung",
      "QUANTITY": "Menge",
      "UNIT": "Einheit",
      "UNIT_PRICE": "Einzelpreis",
      "NET": "Netto",
      "VAT_RATE": "USt-Satz",
      "DISCOUNT": "Rabatt"
    },
    "PLACEHOLDER": {
      "ITEM_NUMBER": "z. B. 1",
      "PRODUCT_NUMBER": "Artikelnummer des Lieferanten",
      "EAN": "13-stellige Nummer",
      "DESCRIPTION": "Bezeichnung laut Beleg",
      "QUANTITY": "z. B. 12",
      "UNIT": "z. B. Stk",
      "UNIT_PRICE": "0,00",
      "NET": "0,00",
      "VAT_RATE": "z. B. 20",
      "DISCOUNT": "z. B. 10 %"
    },
    "PDF": {
      "PAGE_PREV": "Vorherige Seite",
      "PAGE_NEXT": "Nächste Seite",
      "ZOOM_OUT": "Verkleinern",
      "ZOOM_IN": "Vergrößern",
      "FIT_WIDTH": "An Breite anpassen",
      "ZOOM_RESET": "Originalgröße (100 %)",
      "META": {
        "TOGGLE": "Belegdaten ein-/ausblenden",
        "SUPPLIER": "Lieferant",
        "RECEIPT_NUMBER": "Belegnummer",
        "RECEIPT_DATE": "Belegdatum",
        "DOCUMENT_TYPE": "Belegart",
        "PAGES": "Seiten"
      }
    },
    "DOCUMENT_TYPE": {
      "RECHNUNG": "Rechnung",
      "ANGEBOT": "Angebot",
      "GUTSCHRIFT": "Gutschrift",
      "LIEFERSCHEIN": "Lieferschein"
    },
    "EXTRACTION_METHOD": {
      "TEMPLATE": "Lieferanten-Template angewandt",
      "PIPELINE": "KI-Pipeline"
    },
    "META": {
      "ADD_FIELD": "+ Feld hinzufügen",
      "KEYBOARD_HINT": "↑ ↓ Feld wechseln · ← → Tab wechseln",
      "CATEGORY_PLACEHOLDER": "Feld wählen …",
      "CATEGORY": {
        "CASH_DISCOUNT1": "Skonto 1 Satz",
        "DAYS1": "Skonto 1 Frist",
        "CASH_DISCOUNT2": "Skonto 2 Satz",
        "DAYS2": "Skonto 2 Frist"
      },
      "SUPPLIER": {
        "TITLE": "Lieferant",
        "NAME": "Name",
        "ADDRESS": "Adresse",
        "UID": "UID-Nummer",
        "GLN": "GLN"
      },
      "RECIPIENT": {
        "TITLE": "Empfänger",
        "ADDRESS_BILLING": "Rechnungsadresse",
        "GLN_BILLING": "GLN Rechnungsadresse",
        "ADDRESS_DELIVERY": "Lieferadresse",
        "GLN_DELIVERY": "GLN Lieferadresse"
      },
      "RECEIPT": {
        "TITLE": "Beleg",
        "RECEIPT_NUMBER": "Belegnummer",
        "RECEIPT_DATE": "Belegdatum",
        "VALID_UNTIL": "Gültig bis",
        "CUSTOMER_NUMBER": "Kundennummer",
        "PROJECT_NAME": "Projekt",
        "BILLING_PERIOD": "Abrechnungszeitraum",
        "DELIVERY_NOTE_NUMBER": "Lieferscheinnummer",
        "NET_DAYS": "Zahlungsziel (Tage)"
      },
      "TOTALS": {
        "TITLE": "Summen",
        "NET": "Netto",
        "VAT_RATE": "USt-Satz (%)",
        "VAT": "USt-Betrag",
        "GROSS": "Brutto",
        "CURRENCY": "Währung"
      },
      "ADJUSTMENT": {
        "CASH_DISCOUNT_RATE": "Skonto {{n}} Satz",
        "CASH_DISCOUNT_DAYS": "Skonto {{n}} Frist",
        "INTEREST_RATE": "Zins {{n}} Satz",
        "INTEREST_DAYS": "Zins {{n}} Zeitraum",
        "SURCHARGE": "Zuschlag {{n}}",
        "DISCOUNT": "Rabatt {{n}}",
        "RETENTION": "Einbehalt/Anzahlung {{n}}",
        "UNPROVEN": "(unbewiesen)"
      }
    }
  }
}
